import React, { FC } from "react";
import { ThemeProvider } from "styled-components/macro";
import { Normalize } from "styled-normalize";
import { BrowserRouter, MemoryRouter } from "react-router-dom";

import { defaultTheme } from "./theme/defaultTheme";
import { GlobalStyle } from "./theme/GlobalStyle";

import { App } from "./App";

export const Providers: FC = () => (
  <ThemeProvider theme={defaultTheme}>
    <div>
      <Normalize />
      <GlobalStyle />
      <BrowserRouter basename={`/${process.env.REACT_APP_PREFIX}`}>
        <App />
      </BrowserRouter>
    </div>
  </ThemeProvider>
);

export const TestProviders: FC = ({ children }) => (
  <ThemeProvider theme={defaultTheme}>
    <div>
      <GlobalStyle />
      <MemoryRouter initialEntries={[`/${process.env.REACT_APP_PREFIX}`]}>{children}</MemoryRouter>
    </div>
  </ThemeProvider>
);
